
define("rv!templates/partials/carousel",[],function(){return { v:3,
  t:[ { t:7,
      e:"div",
      a:{ id:"fadeGallery",
        "class":"gallery-area grid_8 alpha" },
      f:[ { t:7,
          e:"ul",
          a:{ "class":"gallery" },
          f:[ { t:4,
              f:[ { t:7,
                  e:"li",
                  a:{ style:"background-color:#000;text-align:center;" },
                  f:[ { t:7,
                      e:"img",
                      a:{ src:[ { t:2,
                            r:"FullUrl" } ],
                        alt:[ { t:2,
                            r:"Caption" } ] } } ] } ],
              n:52,
              r:"images" } ] },
        " ",
        { t:7,
          e:"div",
          a:{ "class":"thumbnails" },
          f:[ { t:7,
              e:"div",
              a:{ "class":"mask" },
              f:[ { t:7,
                  e:"ul",
                  f:[ { t:4,
                      f:[ { t:7,
                          e:"li",
                          f:[ { t:7,
                              e:"img",
                              a:{ src:[ { t:2,
                                    r:"ThumbUrl" } ],
                                alt:[ { t:2,
                                    r:"Caption" } ],
                                title:[ { t:2,
                                    r:"Caption" } ] } } ] } ],
                      n:52,
                      r:"images" } ] } ] } ] } ] } ] };});
